const jobs = {
  update: {
    summary: {
      supplier: 'Flota',
      notRouted: 'No Distribuido',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'Flota',
      },
    },
  },
  table: {
    actions: {
      route: 'Distribuir',
    },
    statuses: {
      new: 'No Distribuido',
      routed: 'Distribuido',
    },
    cells: {
      supplier: {
        none: 'Sin Flotas',
      },
    },
    filters: {
      supplier: 'Flotas',
    },
    headers: {
      supplier: 'Flotas',
    },
  },
};

export default jobs;
